import { filter, isNil, isEmpty, omit, prop } from 'ramda'

import { collection as actions } from '../actions'
import { initialValues } from '../selectors/collection'

export const reducer = {}

reducer[actions.SET_FETCHING] = ({
  state,
  action: {
    payload: { id, isFetching }
  }
}) => ({
  ...state,
  isFetching: {
    ...prop('isFetching', state),
    [id]: isFetching
  }
})

reducer[actions.SET_FILTERS] = ({
  state,
  action: {
    payload: { id, filters }
  }
}) => ({
  ...state,
  filters: {
    ...(state && state.filters),
    [id]: {
      ...filter(Boolean, filters)
    }
  },
  page: {
    ...(state && state.page),
    [id]: initialValues.page
  }
})

reducer[actions.SET_FILTER] = ({
  state,
  action: {
    payload: { id, filter }
  }
}) => ({
  ...state,
  filters: {
    ...(state && state.filters),
    [id]: {
      ...(!isNil(filter.value) && !isEmpty(filter.value)
        ? {
            ...state.filters[id],
            [filter.key]: filter.value
          }
        : omit([filter.key], state.filters[id]))
    }
  },
  page: {
    ...(state && state.page),
    [id]: initialValues.page
  }
})

reducer[actions.SET_PAGE] = ({
  state,
  action: {
    payload: { id, page }
  }
}) => ({
  ...state,
  page: {
    ...prop('page', state),
    [id]: page
  }
})

reducer[actions.SET_PER_PAGE] = ({
  state,
  action: {
    payload: { id, perPage }
  }
}) => ({
  ...state,
  perPage: {
    ...prop('perPage', state),
    [id]: perPage
  }
})

reducer[actions.SET_SORT] = ({
  state,
  action: {
    payload: { id, sortBy, isSortAscending }
  }
}) => ({
  ...state,
  sortBy: {
    ...prop('sortBy', state),
    [id]: sortBy
  },
  isSortAscending: {
    ...prop('isSortAscending', state),
    [id]: isSortAscending
  }
})

reducer[actions.SET_ASOF] = ({
  state,
  action: {
    payload: { id, asof }
  }
}) => ({
  ...state,
  asof: {
    ...prop('asof', state),
    [id]: asof
  }
})

reducer[actions.SET_LAST_FETCHED_STATE] = ({
  state,
  action: {
    payload: { id, lastFetchedState }
  }
}) => ({
  ...state,
  lastFetchedState: {
    ...state.lastFetchedState,
    [id]: lastFetchedState
  }
})
